const environment = getEnvironment();

let apiURL = "";

if (environment === "development") {
  apiURL = "http://localhost:4000";
}
if (environment === "production") {
  apiURL = "https://api.jobego.co";
}

const APP_URL = environment === "development" ? "http://localhost:8080" : "https://app.jobego.co";
const CANDIDATE_URL = environment === "development" ? "http://localhost:3000" : "https://jobego.co";
const SENTRY_URL = "https://6af6a8810dfc410c2411b69153000a60@sentry.selego.co/197";

function getEnvironment() {
  if (window.location.href.indexOf("app-staging") !== -1) return "staging";
  if (window.location.href.indexOf("localhost") !== -1 || window.location.href.indexOf("127.0.0.1") !== -1) return "development";
  return "production";
}

export { apiURL, SENTRY_URL, environment, APP_URL, CANDIDATE_URL };
